import { Component } from '@angular/core';
import { ServicesHeroSectionComponent } from "./components/services-hero-section/services-hero-section.component";
import { ServicesDetailsSectionComponent } from "./components/services-details-section/services-details-section.component";
import { ServicesCtaSectionComponent } from "./components/services-cta-section/services-cta-section.component";

@Component({
  selector: 'app-services-page',
  imports: [ServicesHeroSectionComponent, ServicesDetailsSectionComponent, ServicesCtaSectionComponent],
  templateUrl: './services-page.component.html',
  styleUrl: './services-page.component.css',
})
export class ServicesPageComponent {

}
